import type { IGetDashboardFilters } from "@api";
import { useCallback } from "react";
import { axiosV2 } from "./axios";

export interface ICountFilterViews {
  _id: string;
  filters: IGetDashboardFilters;
}

export type ICountFilterViewsBody = ICountFilterViews[];

export type ICountFilterViewsResult = Record<string, number>;

export const usePostFilterViewsCount = () => {
  const [state, execute, cancel] = axiosV2<ICountFilterViewsResult, ICountFilterViewsBody, unknown>(
    {
      url: "/candidates/countFilterViews",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (filterViews: ICountFilterViewsBody) => {
      return execute({
        data: filterViews,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
